import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';
import { UIError } from '@/shared/utils/ui-error';
import { ENDPOINT, type OrderChatTokenResponse } from '../types/order-chat';

type UseCaseInput = { id_order: string };

/**
 * PRAT-102: busca o token do chat do pedido (uma vez por pedido). Loja sem o recurso
 * ou pedido já terminado voltam `enabled: false` e o app não mostra o chat.
 */
export class GetOrderChatTokenUseCase implements IUseCase<UseCaseInput, OrderChatTokenResponse> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ id_order }: UseCaseInput): Promise<OrderChatTokenResponse> {
    if (!id_order) throw new UIError('ORDER_NOT_FOUND', 'Pedido não encontrado.');
    try {
      const response = await this.client.sendRequest<OrderChatTokenResponse, undefined>({
        endpoint: `${ENDPOINT}/${id_order}/chat-token`,
        method: HttpMethod.GET,
      });
      return response ?? { enabled: false };
    } catch {
      // 409 (pedido terminou), 404 ou API fora: sem chat, sem erro na tela do pedido.
      return { enabled: false };
    }
  }
}
